module.exports = __webpack_public_path__ + "img/Urlaub.ce63bdcb.jpg";